<template>
	<div class="m-phone">
		<p class="m-phone-title ellipsis">{{title}}</p>
		<div class="m-phone-content">
			<div>
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String
		}
	}
</script>

<style lang="stylus" scoped>
	.m-phone {
		position: relative;
		width: 270px;
		height: 550px;
		background-image: url('~@/assets/image/phone.png');
		background-size: 100% 100%;

		&-title {
			position: absolute;
			left: 50px;
			right: 50px;
			top: 54px;
			font-size: 14px;
			text-align: center;
		}

		&-content {
			position: absolute;
			left: 14px;
			right: 14px;
			top: 80px;
			bottom: 12px;
			border-radius: 0 0 36px 36px;
			overflow: hidden;
			background: #fff;

			> div {
				height: 100%;
				overflow: auto;
			}
		}
	}
</style>